import { useCallback, useState } from "react";
import { IStoredTask, ITaskContextData } from "./tasks";
import { TaskInfoAddRequestTaskTypeEnum } from "@/api/openapi";

/**
 * This is not actually a store, and is used only for the Task Toaster.
 * To reliably access all recieved task messages, refer to data-source-service
 */
export function useTasksContextValue(): ITaskContextData {
    const [tasks, setTasks] = useState<IStoredTask[]>([]);

    const createTask = useCallback(
        (task: IStoredTask) => {
            const newTasks = [...tasks, task];
            setTasks(newTasks);
            console.log("task added: ", task);
        },
        [tasks, setTasks],
    );

    const updateTask = useCallback(
        (task: IStoredTask) => {
            const taskIndex: number = tasks.findIndex(
                (element) => element.taskInfoId === task.taskInfoId,
            );
            console.log("updateTask: got task id: ", taskIndex);
            if (taskIndex !== -1) {
                const newTasks = [...tasks, task];
                console.log("removed: ", newTasks.splice(taskIndex, 1));
                setTasks(newTasks);
                console.log("task updated: ", task);
            }
        },
        [tasks, setTasks],
    );

    const removeTask = useCallback(
        (taskId: string) => {
            const taskIndex: number = tasks.findIndex(
                (element) => element.taskInfoId === taskId,
            );
            console.log("removeTask: got task id: ", taskIndex);
            if (taskIndex !== -1) {
                const newTasks = [...tasks];
                const removedTask = newTasks.splice(taskIndex, 1);
                setTasks(newTasks);
                console.log("task removed: ", removedTask);
            }
        },
        [tasks, setTasks],
    );

    const getTask = useCallback(
        (
            deviceId: string,
            taskType: TaskInfoAddRequestTaskTypeEnum,
        ): IStoredTask | undefined => {
            return tasks.find(
                (element) =>
                    element.deviceIdentity === deviceId &&
                    element.taskType.toLowerCase() === taskType.toLowerCase(),
            );
        },
        [tasks],
    );

    const getTaskFromId = useCallback(
        (taskId: string): IStoredTask | undefined => {
            return tasks.find((element) => element.taskInfoId === taskId);
        },
        [tasks],
    );

    return {
        tasks,
        createTask,
        updateTask,
        removeTask,
        getTask,
        getTaskFromId,
    };
}
